import { render } from "./Routing.vue?vue&type=template&id=ae55e622&ts=true"
import script from "./Routing.vue?vue&type=script&lang=ts"
export * from "./Routing.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__